import { render, staticRenderFns } from "./jewellery-photo-preview.vue?vue&type=template&id=4b56842a"
import script from "./jewellery-photo-preview.vue?vue&type=script&lang=js"
export * from "./jewellery-photo-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports